import { render, staticRenderFns } from "./tokenVerification.vue?vue&type=template&id=d6604b36&"
import script from "./tokenVerification.vue?vue&type=script&lang=js&"
export * from "./tokenVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports